module.exports = __webpack_public_path__ + "images/category_lp/game_console/store_images/4@2x_272e19b214280f8212fe61db8cfed451.png";